var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonoLogoBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 403,
    height: 236,
    viewBox: "0 0 403 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.107 89.3204C285.309 86.7064 281.764 86.3305 280.436 88.7192L260.533 124.519C260.422 124.719 260.335 124.932 260.265 125.15C258.451 130.788 253.157 134.638 247.157 134.638H172.275C170.564 134.638 169.177 133.251 169.177 131.54V110.922C169.177 109.211 170.564 107.823 172.275 107.823H235.154C236.382 107.823 237.493 107.099 237.989 105.976L270.534 32.202C274.363 19.1796 292.951 19.087 296.912 32.0701L334.106 153.959C335.072 157.123 339.732 156.789 340.264 153.523C341.893 143.502 344.089 131.213 345.436 128.602C347.788 124.043 352.519 121.174 357.686 121.174H399.72C401.431 121.174 402.818 122.561 402.818 124.272V144.891C402.818 146.602 401.431 147.989 399.72 147.989H368.118C366.758 147.989 365.557 148.877 365.157 150.177L347.299 208.279C347.245 208.455 347.175 208.629 347.088 208.791C341.335 219.447 325.355 217.941 321.798 206.284L286.107 89.3204Z",
    fill: "url(#paint0_linear_4841_2441)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.213 60.2121C219.277 59.5976 219.643 58.2354 219.009 57.1829C206.013 35.6231 186.446 18.7689 163.154 9.11691C139.177 -0.819294 112.591 -2.56797 87.5181 4.14197C62.4455 10.8519 40.2867 25.6457 24.4768 46.2298C8.66697 66.814 0.089195 92.0388 0.0732644 117.994C0.0573339 143.949 8.60413 169.184 24.3887 189.788C40.1733 210.391 62.3139 225.212 87.3783 231.953C112.443 238.693 139.031 236.977 163.021 227.071C186.324 217.447 205.912 200.617 218.934 179.073C219.57 178.022 219.205 176.659 218.142 176.043L198.139 164.462C197.075 163.846 195.716 164.211 195.074 165.259C185.096 181.554 170.196 194.285 152.5 201.593C134.117 209.185 113.743 210.5 94.537 205.334C75.3308 200.169 58.3651 188.812 46.2698 173.024C34.1745 157.236 27.6253 137.899 27.6375 118.011C27.6497 98.1221 34.2226 78.7931 46.3373 63.02C58.4519 47.2469 75.4316 35.9108 94.6441 30.7692C113.857 25.6275 134.229 26.9675 152.602 34.5813C170.29 41.9109 185.174 54.6605 195.132 70.9682C195.773 72.0171 197.131 72.3835 198.195 71.769L218.213 60.2121Z",
    fill: "url(#paint1_linear_4841_2441)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4841_2441",
    x1: 300.927,
    y1: 133.897,
    x2: 300.927,
    y2: 188.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4841_2441",
    x1: 123.707,
    y1: 136,
    x2: 123.707,
    y2: 202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonoLogoBig);
export default __webpack_public_path__ + "static/media/monoLogoBig.dd5f0399d7a13419e54f1fadf6b8a69c.svg";
export { ForwardRef as ReactComponent };